import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
import { colors } from '../../utils';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    notesBox: {
      width: '100%',
      backgroundColor: theme.palette.background.paper,
      position: 'relative',
      overflow: 'auto',
      maxHeight: 200
    },
    notesIco: {
      paddingLeft: 19
    },
    notesTitle: {
      paddingLeft: 9
    },
    addNoteGrid: {
      textAlign: 'right',
      flex: 1
    },
    addNoteButton: {
      marginRight: 4
    },
    dialogHeaderFooter: {
      background: colors.defaultGrey
    },
    noNotesChip: {
      background: colors.defaultGrey,
      marginLeft: theme.spacing(2)
    },
    tableContainer: {
      maxHeight: 400,
      marginTop: theme.spacing(2)
    },
    noteTextCell: {
      maxWidth: 400,
      wordWrap: 'break-word'
    },
    tableHeader: {
      background: colors.defaultGrey
    },
    tableHeaderFooter: {
      background: colors.defaultGrey
    }
  })
);
